"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditFacilityReceivableOriginationSummaryInfoSchema = exports.BaseRepaymentVintageInputInsightsDataSchema = exports.BaseProfitVintageInputInsightsDataSchema = exports.BasePrincipalInsightsDataSchema = void 0;
const zod_1 = require("zod");
const Utils_1 = require("./Utils");
// ********************************************
//                  PRINCIPAL
// ********************************************
// Zod schema for BasePrincipalInsightsData
// This typing coincides with our report structure so can easily typeguard queried data results
exports.BasePrincipalInsightsDataSchema = zod_1.z.object({
    reportingDate: Utils_1.ZodFullDateStrStruct,
    currentPrincipalBalance: zod_1.z.number(),
    commitmentAmount: zod_1.z.number(),
});
// This typing coincides with our report structure so can easily typeguard queried data results.
// Rather than managing cohorting logic within the query itself, we'll manage it afterwards with
// application utility logic as this will also help with subsequent alterations (e.g., week vs month)
// Zod schema for BaseProfitVintageInputInsightsData
exports.BaseProfitVintageInputInsightsDataSchema = zod_1.z.object({
    reportingDate: Utils_1.ZodFullDateStrStruct,
    originationDate: Utils_1.ZodFullDateStrStruct,
    totalVintageCalcValue: zod_1.z.number(),
    totalNormalizedIsChargedOffVintageCalcValue: zod_1.z.number(),
    totalNormalizedIsDelinquentVintageCalcValue: zod_1.z.number(),
});
// Zod schema for BaseRepaymentVintageInputInsightsData
exports.BaseRepaymentVintageInputInsightsDataSchema = zod_1.z.object({
    originationDate: Utils_1.ZodFullDateStrStruct,
    finleyRepaymentDate: Utils_1.ZodFullDateStrStruct,
    cumulativeRepayments: zod_1.z.number(),
});
// Zod schema for CreditFacilityReceivableOriginationSummaryInfo
exports.CreditFacilityReceivableOriginationSummaryInfoSchema = zod_1.z.object({
    originationDate: Utils_1.ZodFullDateStrStruct,
    originatedReceivablesCount: zod_1.z.number(),
    totalInitialBalanceOfOriginatedReceivables: zod_1.z.number().optional(),
});
//# sourceMappingURL=Insights.js.map